import script from "./SddsMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SddsMessage.vue?vue&type=script&setup=true&lang=ts"

import "./SddsMessage.vue?vue&type=style&index=0&id=133082ae&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133082ae"]])

export default __exports__